import React from "react";
import { FaFilePdf, FaFileAlt, FaImage } from "react-icons/fa";
import './style.css'

const DocumentCard = ({ title, file }) => {
  if (!file) {
    return (
        <div>
              <h3 className="document-title font-semibold text-gray-700 mb-2">{title}</h3>   
      <div className="document-card flex flex-col items-center justify-center p-6 border rounded-lg text-gray-500 bg-gray-50">
        <FaFileAlt className="text-4xl mb-2 text-gray-400" />
        <span className="no-doc">No document</span>
      </div>
      </div>
    );
  }

  const extension = file.split(".").pop().toLowerCase();

  const isImage = ["jpg", "jpeg", "png", "gif", "webp"].includes(extension);
  const isPdf = extension === "pdf";

  return (
    <div className="document-card p-2 bg-white">
      <h3 className="document-title font-semibold text-gray-700 mb-2">{title}</h3>              
      <div className="document-image-container flex items-center justify-center overflow-hidden">
        {isImage ? (
          <img
            src={file}
            alt={title}
            className="document-image max-h-full max-w-full object-contain"
          />
        ) : isPdf ? (
          <div className="flex flex-col items-center justify-center">
            <FaFilePdf className="text-red-500 text-6xl mb-2" />
            <a
              href={file}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-teal-600 underline hover:text-teal-700"
            >
              View PDF
            </a>
          </div>
        ) : (
          <div className="flex flex-col items-center justify-center">
            <FaFileAlt className="text-gray-500 text-6xl mb-2" />
            <a
              href={file}
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-teal-600 underline hover:text-teal-700"
            >
              View Document
            </a>
          </div>
        )}
      </div>
    </div>
  );
};

export default DocumentCard